import Courses from "./api/coursesAPI";
import auth from "@/service/api/AuthAPI";

export default {
  Courses,
  auth,
};
